import { memo } from 'react';
import classNames from 'classnames';

import { Loader } from 'components/Loader';

import { ReactComponent as PlusIcon } from 'assets/images/plus.svg';

import styles from './styles.module.scss';

type Props = {
  title: string;
  className?: string;
  showPlusIcon?: boolean;
  loading?: boolean;
  onClick: () => void;
};

export const Button: React.FC<Props> = memo(function Button({
  title,
  className,
  showPlusIcon = false,
  loading = false,
  ...restButtonProps
}) {
  return (
    <button
      type="button"
      className={classNames(styles.button, className)}
      disabled={loading}
      {...restButtonProps}>
      {loading ? (
        <Loader light loading />
      ) : (
        <>
          {showPlusIcon && <PlusIcon />}
          {title}
        </>
      )}
    </button>
  );
});
